import React, { useEffect, useRef, useState } from "react";

/** A number that flips over when it changes — green flipping up, red flipping down.
 *  Nothing animates on first paint, only on a real change. */
export const FlipNumber = ({ value, format, className = "", testid }) => {
  const prev = useRef(value);
  const [dir, setDir] = useState(null);

  useEffect(() => {
    if (Number(value) === Number(prev.current)) return;
    const up = Number(value) > Number(prev.current);
    prev.current = value;
    setDir(up ? "up" : "down");
    const t = setTimeout(() => setDir(null), 700);
    return () => clearTimeout(t);
  }, [value]);

  const text = format ? format(value) : String(value);
  return (
    <span className="flip-num-slot">
      <span key={text} data-testid={testid}
        className={`flip-num ${dir === "up" ? "flip-num-up" : dir === "down" ? "flip-num-down" : ""} ${className}`}>
        {text}
      </span>
    </span>
  );
};
